/** Bottom-left recenter button overlayed on the map. */
export function RecenterControl({
  onClick,
  label = "Recentralizar",
  title = "Recentralizar mapa",
}: {
  onClick: () => void;
  label?: string;
  title?: string;
}) {
  return (
    <div
      style={{
        position: "absolute",
        bottom: "12px",
        left: "12px",
        zIndex: 10,
      }}
    >
      <button
        type="button"
        onClick={onClick}
        title={title}
        style={{
          padding: "6px 12px",
          borderRadius: "8px",
          fontSize: "12px",
          fontWeight: 500,
          background: "white",
          color: "#1A1814",
          border: "1px solid #E8E6E3",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="3" />
          <path d="M12 2v4M12 18v4M2 12h4M18 12h4" />
        </svg>
        {label}
      </button>
    </div>
  );
}
